
export const isDemoMode = () => {
    try {
        const url = window.location.href;
        return url.includes("web-demo");
    } catch {
        return false;
    }
};
